import ReactDOM from 'react-dom';
import App from './App';
import { withAllProviders } from './HOK/withAllProvider'; //

ReactDOM.render(withAllProviders(App), document.getElementById('root'));
//
